import { api } from "../helpers";

const prefix = "/tournaments/presets";
const prefix2 = "/tournaments/presetItem";

export const getPresetItemsList = (param, token) => {
	return api(`${prefix}/items`, "GET", undefined, param, token);
};

export const getPresetDetail = (param, token) => {
	const { id, ...rest } = param;

	return api(`${prefix2}/${id}`, "GET", undefined, rest, token);
};

export const getPresetItemDetail = (param, token) => {
	const { id, ...rest } = param;

	return api(`${prefix}/items/${id}`, "GET", undefined, rest, token);
};

export const postPresetItem = (payload, token) => {
	return api(`${prefix}/items`, "POST", payload, undefined, token);
};

export const updatePresetItem = (payload, token) => {
	const { id, ...rest } = payload;

	return api(`${prefix}/items/${id}`, "PUT", rest, undefined, token);
};
